import { call, put } from '@redux-saga/core/effects';
import { apiGeneral, notify } from 'services';
import {
  FetchEmbedZohoActions as Actions,
  FetchEmbedZohoRequestAction as RequestAction,
} from 'store/ducks/zohoDashboard';
import { requestErrorHandler } from "utils";

export function* fetchZohoEmbedUrlRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;  
  try {
    const { data } = yield call(apiGeneral.get, `zoho-embed/${id}`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
